import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, RouteComponentProps, useMatch, useLocation} from '@reach/router'
import { selectUser } from '../../store/users/userSlice';
import styled from 'styled-components'
import { Icon } from '@iconify/react';
import bxNoEntry from '@iconify/icons-bx/bx-no-entry';
import { colour_lookup } from '../common/Colours';
import { notNull } from '../../lib/typeCheck';

const MenuLink = props => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        style: {
          'borderBottom': isCurrent ? "2px solid #233567" : "0"
        }
      };
    }}
  />
);

const StyledSubMenu = styled.div<{ map: Boolean; }>`
  position: absolute;
  top: 0;
  left: 0;
  // border-bottom: 1px solid #AAA;
  z-index: 2;
  ${props => props.map? 'background: rgba(255,255,255,0.75);' : null}
  border-radius: 25px;
  margin: 10px;
  ${props => props.map? 'box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);': null}
  
  ul {
    display: flex;
    list-style: none;
    margin: 0 10px 0 10px;
  
    
    li {
      display: block;
      margin: 0 10px;
      height: 47px;
      position: relative;
      
      a {
        text-decoration: none;
        height: 47px;
        line-height: 49px;
        color: #707070;
        padding-bottom: 3px;
        font-size: 16px;
      }
    }
  }
`;
const StyledIcon = styled(Icon)`
  transform: translateY(0.2rem) !important;
  margin-left: 10px;
`;

export const SubMenu = ({ features}: { features: any;}) => {
  
  const match = useMatch('/devices');
  const map = match? true : false;  
  
  return (
    <StyledSubMenu map={map}>
      <ul>
        {features.sub.map?
          <li>
            <MenuLink to="./">Map</MenuLink>
          </li>
        : null }
        {features.sub.list?
          <li>
            <MenuLink to="list">List</MenuLink>
          </li>
        : null }
        {features.sub.alarms?
          <li>
            <MenuLink to="alarms">Alarms</MenuLink>
          </li>
        : null}
        {features.sub.export?
          <li>
          <MenuLink to="export">Export</MenuLink>
          </li>
        : null}
        {features.sub.power?
          <li>
          <MenuLink to="power">Power</MenuLink>
          </li>
        : null}
      </ul>
    </StyledSubMenu>
  )
}

export const FlexibleSubMenu = ({ features, nodes }: { features: any; nodes: any }) => {
  const match = useMatch('/devices');
  const map = match? true : false;  

  // Get current user details
  const current_user = useSelector(selectUser);  
  
  return (
    <StyledSubMenu map={map}>
      <ul> 
        {       
        features.map((feature, index) => (  
          feature.name === 'Power' ?    
          <li key={index}>                        
            <MenuLink to={feature.path}>{feature.name}</MenuLink> 
            { nodes.length>=1 && nodes[0].icons.power !== null && nodes[0].icons.power !== 'undefined' &&   
            <StyledIcon color={colour_lookup(nodes[0].icons.power)} align='right' width='16px' icon={bxNoEntry}/>
          }
          </li> 
          :
          feature.name === 'NX-42WR Audio'?
          <li key={index}>                        
            <MenuLink to={feature.path}>{feature.name}</MenuLink> 
            { nodes.length>=1 && nodes[0].icons.rawaudio !== null && nodes[0].icons.rawaudio !== 'undefined' &&
            <StyledIcon color={colour_lookup(nodes[0].icons.rawaudio)} align='right' width='16px' icon={bxNoEntry}/>
            }
          </li>  
          : 
          feature.name === 'Weekly Restart'?
          <li key={index}>                        
            <MenuLink to={feature.path}>{feature.name}</MenuLink>
            { nodes.length>=1 && nodes[0].icons.reboot !== null && nodes[0].icons.reboot !== 'undefined' &&
            <StyledIcon color={colour_lookup(nodes[0].icons.reboot)} align='right' width='16px' icon={bxNoEntry}/> 
            }
          </li>
          :
          // Display Capability tab only if the user account is permitted
          feature.name === 'Capabilities'?
            notNull(current_user.id) && current_user.permitted_actions.includes('send_command')?
              <li key={index}>
                <MenuLink to={feature.path}>{feature.name}</MenuLink>
              </li>
            : null
          :
          <li key={index}>
            <MenuLink to={feature.path}>{feature.name}</MenuLink>
          </li>
        ))}       
        
      </ul>
    </StyledSubMenu>
  )
}

